import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="text-xs font-bold uppercase tracking-[0.35em] text-electric-bright">
    {children}
  </p>
);

export const SectionHead = ({ overline, title, className = "" }) => (
  <Reveal className={className}>
    <Overline>{overline}</Overline>
    <h2 className="mt-4 font-display text-4xl sm:text-5xl font-semibold tracking-tight uppercase leading-[1.02] text-white max-w-3xl">
      {title}
    </h2>
    <div className="mt-6 h-px w-24 bg-electric" />
  </Reveal>
);
